import servicesConfig, { CustomAxiosHeaders } from '../config/services'

import { AxiosResponse } from 'axios'
import { requests } from '.'

type ISegmentLocationQuery = {
  companyId: string
  locationId: string
  userId: string
}

type IUpdateStepAsCompletedQuery = {
  companyId: string
  locationId: string
  eventName: string
}

type ISegmentAgencyQuery = {
  companyId: string
  userId?: string
}

type IGetActionProgressQuery = {
  companyId: string
  userId: string
  segmentId: string
  type: string
  locationId?: string
  productId?: string
}

type IGetSegmentAssignedQuery = {
  companyId: string
  locationId?: string
}

// Configure request setup
const serviceName = 'LaunchpadService'
const host = servicesConfig.Launchpad as string
const opts: CustomAxiosHeaders = { host, serviceName, useNewToken: true }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const LaunchpadService = {
  segmentDetailForLocation: (params: ISegmentLocationQuery) =>
    request()
      .get(
        `/segments/location/details?companyId=${params.companyId}&locationId=${params.locationId}&userId=${params.userId}`
      )
      .then(responseBody),

  updateStepAsCompleted: (body: IUpdateStepAsCompletedQuery) =>
    request().put(`/segments/location/step-completed`, body).then(responseBody),

  getActionProgress: (body: IGetActionProgressQuery) => {
    const { companyId, userId, segmentId, type, locationId = '', productId } = body
    let query = `companyId=${companyId}&userId=${userId}&segmentId=${segmentId}&type=${type}`

    if (locationId) query += `&locationId=${locationId}`
    if (productId) query += `&productId=${productId}`

    // console.log(`query: `, query)
    return request().get(`/segments/action/progress?${query}`).then(responseBody)
  },
  getSegmentAssigned: (params: IGetSegmentAssignedQuery) => {
    let query = ''
    if (params.locationId) query += `&locationId=${params.locationId}`

    return request().get(`/segments/assigned/${params.companyId}?${query}`).then(responseBody)
  },
}

export default LaunchpadService
